// extracted by mini-css-extract-plugin
export default {"wrapper":"SkeletonCardGroupPlants_wrapper__syXog"};